module.exports = __webpack_public_path__ + "media/banner/banner-4-c72470c5.jpg";